<template>
    <div id="exammainGuid" style="">
        <h3>“知觉速度与准确性”说明</h3>
        <p>本部分共60题，时限10分钟，其中阅读说明2分钟，作答8分钟。此部分固定在第一部分作答，不允许先作答其他部分。阅读说明满2分钟后，可开始答题，作答满8分钟后方能选择其他部分继续作答。</p>
        <p>
            <font>本部分每道试题分值相同，采用倒扣分的方式计分，扣完本部分总分为止。答对则得分，答错倒扣分，不答不得分。</font>
        </p>
        <p>
            <font>本部分包括三种类型的题目：</font>
        </p>
        <p>
            <font></font>
        </p>
        <p>第一种类型的题目：定位数字区间</p>
        <p>给定一个包含有一些数字区间的表格，让你确定某一给定的数字属于表格中的哪一数字区间，这一区间的标号就是正确答案。<br>例题：</p>
        <table>
            <tbody>
                <tr>
                    <td>①</td>
                    <td>②</td>
                    <td>③</td>
                    <td>④</td>
                    <td>⑤</td>
                </tr>
                <tr>
                    <td>3871~4783</td>
                    <td>2134~2765</td>
                    <td>5763~6438</td>
                    <td>8538~9921</td>
                    <td>0853~2093</td>
                </tr>
                <tr>
                    <td>7838~8420</td>
                    <td>4921~5636</td>
                    <td>7112~7789</td>
                    <td>6780~7093</td>
                    <td>6448~6721</td>
                </tr>
            </tbody>
        </table>
        <div class="topic">
            <p>例题1．6623</p>
            <p>
            </p>
            <ul>
                <li>A．①</li>
                <li>B．② </li>
                <li>C．③</li>
                <li>D．④</li>
                <li>E．⑤</li>
            </ul>
            <p></p>
        </div>
        <div class="topic">
            <p>例题2．5022</p>
            <p>
            </p>
            <ul>
                <li>A．①</li>
                <li>B．② </li>
                <li>C．③</li>
                <li>D．④</li>
                <li>E．⑤</li>
            </ul>
            <p></p>
        </div>
        <div>解答：</div>
        <p>
        </p>
        <ul>
            <li style="width:100%;">题1的数字在6448~6721之间，所在区间的标号为⑤，故答案为E；</li>
            <li style="width:100%;">题2的数字在4921~5636之间，所在区间的标号为②，故答案为B。</li>
        </ul>
        <p></p>
        <p>
            <font>第二种类型的题目：寻找相同字符数量</font>
        </p>
        <p>给定一个词表，要求你将每道题所给的五个词与词表中的词相对照，找出包含在词表中词的个数，如果所给的词没有一个包含在词表中，答案即为0。<br> 例题：</p>
        <div class="box">
            <span>功德</span>
            <span>供奉</span>
            <span>解脱</span>
            <span>黄昏</span>
            <span>呜咽</span>
            <span>明晰</span>
            <span>承受</span>
            <span>痴迷</span>
            <span>贿赂</span>
            <span>讽刺</span>
            <span>风韵</span>
            <span>鼎盛</span>
            <span>违反</span>
            <span>垂青</span>
            <span>表白</span>
        </div>
        <div class="topic">
            <p>例题3．明晰　供养　功德　割爱　违犯</p>
            <ul>
                <li>A．0 </li>
                <li>B．1</li>
                <li>C．2</li>
                <li>D．3</li>
                <li>E．4</li>
            </ul>
            <p>例题4．垂直 解放 贿赂 表现 痴呆</p>
            <ul>
                <li>A．0 </li>
                <li>B．1</li>
                <li>C．2</li>
                <li>D．3</li>
                <li>E．4</li>
            </ul>
        </div>
        <div>解答：</div>
        <p>
        </p>
        <ul>
            <li style="width:100%;">题3中“明晰”、“功德”包含在词表中，故包含在词表中词的个数为2，答案为C；</li>
            <li style="width:100%;">题4中所给的词只有一个包含在词表中，故答案为B。</li>
        </ul>
        <p></p>
        <p>
            <font>第三种类型的题目：字符替换核对</font>
        </p>
        <p>给定一个数字或字母与汉字的对应表，要求你判断题目中用数字或字母替换汉字时，哪一个选项替换得完全正确。<br> 例题：</p>
        <table>
            <tbody>
                <tr>
                    <td>立</td>
                    <td>木</td>
                    <td>川</td>
                    <td>州</td>
                    <td>大</td>
                    <td>手</td>
                    <td>太</td>
                    <td>平</td>
                </tr>
                <tr>
                    <td>L</td>
                    <td>0</td>
                    <td>6</td>
                    <td>4</td>
                    <td>Q</td>
                    <td>7</td>
                    <td>9</td>
                    <td>P</td>
                </tr>
            </tbody>
        </table>
        <div class="topic">
            <p>例题5：立川手平</p>
            <ul>
                <li>A．LQ74</li>
                <li>B．76QP</li>
                <li>C．L67P</li>
                <li>D．L69P</li>
                <li>E．L67Q</li>
            </ul>
            <p>例题6：太州木大</p>
            <ul>
                <li>A．Q607</li>
                <li>B．940Q </li>
                <li>C．9607</li>
                <li>D．96Q7</li>
                <li>E．049Q</li>
            </ul>
        </div>
        <div>解答：</div>
        <p>
        </p>
        <ul>
            <li style="width:100%;">题5中与“立川手平”对应的数字或字母是“L67P”，故答案为C；</li>
            <li style="width:100%;">题6中与“太州木大”对应的数字或字母是“940Q”，故答案为B。</li>
        </ul>
        <p></p>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
#exammainGuid {
    background: #edfade;
    margin: 0px auto;
    padding: 20px 20px 0 20px ;
    height: calc(100% - 90px);
    overflow: auto;
}

#exammainGuid h3 {
    font-size: 24px;
    font-family: '\65B9\6B63\5C0F\6807\5B8B\7B80\4F53';
    text-align: center;
    line-height: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 55px;
}

#exammainGuid p {
    font-size: 21px;
    color: #000;
    text-indent: 32px;
    line-height: 40px;
    overflow: hidden;
}

#exammainGuid table {
    width: 500px;
    margin: 50px auto;
    background: #fff;
    border-collapse: collapse;
}

th,
td {
    border: 1px solid #d7d7d7;
    padding: 18px 0;
    text-align: center;
    font-size: 14px;
    color: #666666;
}

#exammainGuid .topic {
    display: block;
}

#exammainGuid .topic p {
    text-indent: 0;
    font-size: 15px;
}

#exammainGuid ul {
    padding-left: 30px;
    line-height: 30px;
    overflow: hidden;
}

ol,
ul {
    list-style: none;
}
#exammainGuid ul li {
    float: left;
    margin-right: 25px;
}
#exammainGuid .box {
    border: 1px solid #000;
    width: 293px;
    margin: 20px auto;
}
#exammainGuid .box span {
    display: inline-block;
    margin: 10px;
}
</style>